import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=6cdc525d&"
import script from "./StarRating.js?vue&type=script&lang=js&"
export * from "./StarRating.js?vue&type=script&lang=js&"
import style0 from "./StarRating.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports